import BaseApi from '@core/api/model';

export class EventApi extends BaseApi {
    static resource = 'events';
}

export default EventApi;
